import React, { type SyntheticEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import ComponentWithAnalytics from '@atlassian/jira-analytics-web-react/src/utils/component-with-analytics.tsx';
import FieldCopyText from '@atlassian/jira-common-components-field-copy-text/src/view.tsx';
import { useFlagsService, type FlagConfiguration } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages';

type Props = {
	issueUrl: string;
};

export const showCopySuccessfulFlag = (): FlagConfiguration => ({
	type: 'success',
	title: messages.copySuccessTitle,
	description: messages.copySuccessMessage,
});

const DropdownItemWithAnalytics = ComponentWithAnalytics('dropdownItem', {
	onClick: 'clicked',
})(DropdownItem);

export const CopyToClipboardMenuItem = (props: Props) => {
	const { issueUrl } = props;
	const baseUrl = '';
	const fullIssueUrl = `${window.location.protocol}//${window.location.hostname}${baseUrl}${issueUrl}`;
	const { showFlag } = useFlagsService();
	const { formatMessage } = useIntl();

	return (
		<>
			<FieldCopyText
				shouldFitContainer
				hideFieldText
				label=""
				tooltipLabel=""
				value={fullIssueUrl}
				tooltipDisabled
			>
				<span>
					<DropdownItemWithAnalytics
						onClick={(
							// eslint-disable-next-line @typescript-eslint/no-explicit-any
							e: SyntheticEvent<Record<any, any>>,
							analyticsEvent: UIAnalyticsEvent,
						) => {
							// @ts-expect-error Second argument should be of format "actionSubject action"
							fireUIAnalytics(analyticsEvent, 'dropdownItem', 'copyIssueLink', {
								nextGenProject: true,
							});
							showFlag(showCopySuccessfulFlag());
						}}
					>
						{formatMessage(messages.copyLink)}
					</DropdownItemWithAnalytics>
				</span>
			</FieldCopyText>
		</>
	);
};

export default CopyToClipboardMenuItem;
